import React, { PureComponent } from 'react';
import { BorderBox13 } from '@jiaminghi/data-view-react';
import BrowseCategories from './charts/BrowseCategories';
import UserIdentityCategory from './charts/UserIdentityCategory';
import OfflinePortal from './charts/OfflinePortal';
import Feedback from './charts/Feedback';
import { ModuleTitle } from '../../style/globalStyledSet';
import { connect } from 'dva';
import TrafficSituation from './charts/TrafficSituation';
//import * as echarts from 'echarts';
import DynamicHorizontalStackedBar from './charts/DynamicHorizontalStackedBar'; // 新增
import IndustryPieCharts from './charts/IndustryPieCharts';

import { formatTime } from '../../utils';
import { getMoth,getCurrentPeriod } from '../../utils';
import {
  RightPage,
  RightTopBox,
  RightCenterBox,
  RightBottomBox,
  eviceOrderChart,
} from './style';
import DeviceOrderChart from "./charts/DynamicHorizontalStackedBar";


let motharr = getMoth(5);
//let month = getCurrentPeriod();
const now = new Date();
// const month = now.getMonth(); // 0-11
const day = now.getDate();    // 1-31
const period = Math.min(5, Math.floor((day - 1) / 5)); // 0-5
let baseValues = [502.84, 205.97, 332.79, 281.55, 398.35, 214.02,502.84, 205.97, 332.79, 281.55, 398.35, 214.02];
let baseValues1= [281.55, 398.35, 214.02, 179.55, 289.57, 356.14,281.55, 398.35, 214.02, 179.55, 289.57, 356.14];
let baseValues2= [289.22, 256.78, 310.55, 278.99, 410.22, 356.88, 289.22, 256.78, 310.55, 278.99, 410.22, 356.88];
if(period == 0){
  baseValues[baseValues.length-1] = 30 + Math.random() * 10;
  baseValues1[baseValues.length-1] = 30 + Math.random() * 10;
  baseValues2[baseValues.length-1] = 40 + Math.random() * 10;
}else if(period == 1){
  baseValues[baseValues.length-1] = 60 + Math.random() * 10;
  baseValues1[baseValues.length-1] = 60 + Math.random() * 10;
  baseValues2[baseValues.length-1] = 70 + Math.random() * 10;
}else if(period == 2){
  baseValues[baseValues.length-1] = 100 + Math.random() * 10;
  baseValues1[baseValues.length-1] = 100 + Math.random() * 10;
  baseValues2[baseValues.length-1] = 120 + Math.random() * 10;
}else if(period == 3){
  baseValues[baseValues.length-1] = 140 + Math.random() * 10;
  baseValues1[baseValues.length-1] = 140 + Math.random() * 10;
  baseValues2[baseValues.length-1] = 160 + Math.random() * 10;
}else if(period == 4){
  baseValues[baseValues.length-1] = 180 + Math.random() * 10;
  baseValues1[baseValues.length-1] = 180 + Math.random() * 10;
  baseValues2[baseValues.length-1] = 200 + Math.random() * 10;
}else{
  baseValues[baseValues.length-1] = 220 + Math.random() * 10;
  baseValues1[baseValues.length-1] = 220 + Math.random() * 10;
  baseValues2[baseValues.length-1] = 240 + Math.random() * 10;
}
// 乘以30并四舍五入取整
const result = baseValues.map(value => Math.round(value * 30));
const result1 = baseValues1.map(value => Math.round(value * 30));
const result2 = baseValues2.map(value => Math.round(value * 40));
class index extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      data1:2090,
      data2:1070,
      data3:1550,
      data4:1790,
      taisi:3000,
      persent1:15,
      persent2:25,
      persent3:60,
      trafficSitua: {
        timeList: getMoth(6),
        outData: result,
        inData: result1,
        thirdData: result2, // 新增第三条线数据
      },
      userIdentityCategory: {

        data: [
          {
            name: motharr[0],
            value: 4570,
          },
          {
            name: motharr[1],
            value: 6213,
          },
          {
            name: motharr[2],
            value: 5225,
          },
          {
            name: motharr[3],
            value: 6538,
          },
          {
            name: motharr[4],
            value: 3000,
          },
        ],
      },

      offline: {
        feedback: [
          {
            title: '充电线',
            number: 15,
            color: '#36A2EB',
          },
          {
            title: '售货机',
            number: 25,
            color: '#FF6384',
          },
          {
            title: '充电宝',
            number: 60,
            color: '#FFCE56',
          },
        ],
        offlinePortalData: {
          data1: [5080, 4052, 5001, 6034, 2090],
          data2: [2020, 3082, 2591, 2910, 1070],
          data3: [3010, 4532, 3601, 4654, 1550],
          data4: [4090, 5542, 6561, 4614, 1790],
          xData: getMoth(5),
          barData: [32.2, 60.0, 32.6, 36.4, 53.3],
        },
      },
      // industryData: [
      //   {
      //     groupName: '经营行业',
      //     industries: [
      //       { category: '餐饮行业', value: 3442, sub: '中餐' },
      //       { category: '商铺', value: 2146 },
      //       { category: '酒吧', value: 328 },
      //       { category: '沐足桑拿', value: 331 },
      //       { category: '娱乐场所', value: 107 },
      //       { category: '网吧', value: 71 },
      //     ],
      //   },
      // ],
      // industryData1: [
      //   {
      //     groupName: '交通出行',
      //     industries: [
      //       { category: '高铁站', value: 1077 },
      //       { category: '机场', value: 59 },
      //       { category: '旅游包车客运', value: 2 },
      //       { category: '客运', value: 35 },
      //       { category: '旅游大巴', value: 15 },
      //       { category: '车站定制客运', value: 77 },
      //       { category: '车站客运大巴', value: 8 },
      //       { category: '平台定制客运', value: 3 },
      //     ],
      //   },
      //   {
      //     groupName: '事业单位',
      //     industries: [
      //       { category: '政府部门', value: 39 },
      //       { category: '教育', value: 90 },
      //       { category: '医院', value: 106 },
      //     ],
      //   },
      // ],
    };
  }

  // getCurrentPeriod() {
  //   const now = new Date();
  //   const month = now.getMonth(); // 0-11
  //   const day = now.getDate();    // 1-31
  //   const period = Math.min(5, Math.floor((day - 1) / 5)); // 0-5
  //   return { month, period };
  // }


  componentDidMount() {
    this.setRight();
  }
  setRight() {
      this.timing = setInterval(() => {

      let dateYear = formatTime(new Date(), 'dd');
      let dateDay = formatTime(new Date(), 'HH:mm:ss');

      let strdatedateDay = dateYear+dateDay;
      motharr = getMoth(5);

      if(strdatedateDay=='0100:00:00' || strdatedateDay=='0100:00:00' || strdatedateDay=='0100:00:00' || strdatedateDay=='0100:00:00' || strdatedateDay=='0100:00:00' || strdatedateDay=='0100:00:00' || strdatedateDay=='0100:00:00' || strdatedateDay=='0100:00:00' || strdatedateDay=='0100:00:00' || strdatedateDay=='0100:00:00' || strdatedateDay=='0100:00:00' || strdatedateDay=='0100:00:00'){
        this.state.data1 = 0;
        this.state.data1 = 0;
        this.state.data1 = 0;
        this.state.data1 = 0;
        this.state.taisi = 3000;
      }

      const currentPageVideoList1=[...this.state.offline.offlinePortalData.data1];
      this.state.data1 = this.state.data1  + parseInt(Math.floor(Math.random() * (10 - 1) + 1));
      const currentPageVideoList2=[...this.state.offline.offlinePortalData.data2];
      this.state.data2 = this.state.data2  + parseInt(Math.floor(Math.random() * (10 - 1) + 1));
      const currentPageVideoList3=[...this.state.offline.offlinePortalData.data3];
      this.state.data3 = this.state.data3  + parseInt(Math.floor(Math.random() * (10 - 1) + 1));
      const currentPageVideoList4=[...this.state.offline.offlinePortalData.data4];
      this.state.data4 = this.state.data4  + parseInt(Math.floor(Math.random() * (10 - 1) + 1));
      //console.log(currentPageVideoList1)
      this.state.taisi = this.state.taisi  + 1;


      this.state.persent1 = parseInt(Math.floor(Math.random() * (5) + 10));
      this.state.persent2 = parseInt(Math.floor(Math.random() * (5) + 20));
      this.state.persent3 = 100 -  (this.state.persent1) -    (this.state.persent2);

      this.setState({
        offline: {
          ...this.state.offline,
          offlinePortalData:{
            data1:currentPageVideoList1.map((item, key)=> key==4? this.state.data1:item),
            data2:currentPageVideoList2.map((item, key)=> key==4? this.state.data2:item),
            data3:currentPageVideoList3.map((item, key)=> key==4? this.state.data3:item),
            data4:currentPageVideoList4.map((item, key)=> key==4? this.state.data4:item),
            xData: getMoth(5),
            barData: [32.2, 60.0, 32.6, 36.4, 53.3],
          },
          feedback: [
            {
              title: '充电线',
              //number: this.state.persent1,
              number: 39.7,
            },
            {
              title: '售货机',
              //number: this.state.persent2,
              number: 32.1,
            },
            {
              title: '充电宝',
              //number: this.state.persent3,
              number: 28.2,
            },
          ],
        },
        trafficSitua:{
          timeList: getMoth(6),
          outData: result,
          inData: result1,
          thirdData: result2, // 新增第三条线数据
        },
        userIdentityCategory: {

          data: [
            {
              name: motharr[0],
              value: 4570,
            },
            {
              name: motharr[1],
              value: 6213,
            },
            {
              name: motharr[2],
              value: 5225,
            },
            {
              name: motharr[3],
              value: 6538,
            },
            {
              name: motharr[4],
              value: this.state.taisi,
            },
          ],
        },



      });


    }, 3000);
  }
  render() {

    const { trafficSitua, userIdentityCategory, offline} = this.state;
    return (
      <RightPage>
        
        <RightCenterBox>
          <ModuleTitle>
            <i className='iconfont'>&#xe7fd;</i>
            {/*<span>每月订单金额态势</span>*/}
            <span>行业使用占比</span>
            {/*（样本7936台）*/}
          </ModuleTitle>
          {/*<UserIdentityCategory*/}
          {/*  userIdentityCategory={userIdentityCategory}></UserIdentityCategory>*/}
          {/*<DynamicHorizontalStackedBar data={this.state.industryData} data1={this.state.industryData1} />*/}
          <IndustryPieCharts
            data={{
              business: [
                { value: 3442, name: '餐饮行业' },
                { value: 2146, name: '商铺' },
                { value: 328, name: '酒吧' },
                { value: 331, name: '沐足桑拿' },
                { value: 107, name: '娱乐场所' },
                { value: 71, name: '网吧' }
              ],
              transportation: [
                { value: 1077, name: '高铁站' },
                { value: 59, name: '机场' },
                { value: 77, name: '车站定制客运' },
                { value: 35, name: '客运' },
                { value: 15, name: '旅游大巴' },
                { value: 8, name: '车站客运大巴' },
                { value: 3, name: '平台定制客运' },
                { value: 2, name: '旅游包车客运' },
              ],
              public: [
                { value: 39, name: '政府部门' },
                { value: 90, name: '教育' },
                { value: 106, name: '医院' }
              ]
            }}
          />
        </RightCenterBox>

        <RightBottomBox>
          <BorderBox13 className='right-bottom-borderBox13'>
            <div className='right-bottom'>
              <ModuleTitle>
                <i className='iconfont'>&#xe790;</i>
                <span>每月订单量态势</span>
              </ModuleTitle>
              {/* 反馈 */}
              {/*<div className='feedback-box'>*/}
              {/*  {offline*/}
              {/*    ? offline.feedback.map((item, index) => {*/}
              {/*        return (*/}
              {/*          <div className='feedback-box-item' key={index}>*/}
              {/*            <Feedback FeedbackData={item}></Feedback>*/}
              {/*            <span className='dis-text' >{item.title}</span>*/}
              {/*            /!*style={{color:item.color}}*!/*/}
              {/*          </div>*/}
              {/*        );*/}
              {/*      })*/}
              {/*    : ''}*/}
              {/*</div>*/}
              {/* 门店 */}
              {/*<div className='offline-portal-box'>*/}
              {/*  {offline ? (*/}
              {/*    <OfflinePortal*/}
              {/*      offlinePortalData={offline.offlinePortalData}*/}
              {/*    />*/}
              {/*  ) : (*/}
              {/*    ''*/}
              {/*  )}*/}
              {/*</div>*/}
              <DeviceOrderChart style={{width: '5.375rem', height: '2.875rem'}} className='right-bottom-chart'></DeviceOrderChart>
            </div>
          </BorderBox13>
        </RightBottomBox>

        <RightTopBox>
          <div className='right-top'>
            <ModuleTitle>
              <i className='iconfont'>&#xe7f7;</i>
              <span>每月设备投入态势</span>
            </ModuleTitle>


            {/* 图表 */}

            <TrafficSituation trafficSitua={trafficSitua}></TrafficSituation>

          </div>
        </RightTopBox>
      </RightPage>
    );
  }
}

const mapStateToProps = state => {
  return {
    browseCategories: state.rightPage.browseCategories,
    //userIdentityCategory: state.rightPage.userIdentityCategory,
    //offline: state.rightPage.offline,
    //trafficSitua: state.rightPage.trafficSitua,
    trafficSitua: state.trafficSitua,
    userIdentityCategory: state.userIdentityCategory,
    offline: state.offline,
  };
};

const mapStateToDispatch = dispatch => ({});

export default connect(mapStateToProps, mapStateToDispatch)(index);
